import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";

export default function ProductsBroadcastMessaging() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/broadcast.png"
          alt="Broadcast Messaging"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">
          Broadcast Messaging
        </div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          You <span className="fw-bold">can</span> reach all of the people all
          of the time!{" "}
        </p>
        <p className="fs-5 ">
          If you still need to reach customers, staff and stakeholders promptly
          and on their own device there is no better way than SMS. With delivery
          notifications and the option of reply this is the perfect tool for
          quick succinct important communications.
        </p>
        <p className="fs-5 ">
          The great news is with Boomerang’s broadcast you can access a world of
          capability without the cost. From accessing AI to help succinctly
          craft or translate a message, to escalating and grouping based on
          delivery notification, identifying the specific responses, counting
          responses and triggering further workflows to automatically engage
          opens a world of possibilities for both your organisation and its
          customers and stakeholders.
        </p>
        <p className="fs-5 ">
          Gauge the success of outbound campaigns, automatically manage Opt-in,
          control message length message type, message content and adjust based
          on the analytical data.
        </p>
        <p className="fs-5 ">
          Have a single place to gather reports, manage access to the software
          and your data, and ensure compliance that capability and cost are all
          managed within the law of the geography it is being used.
        </p>
        <p className="fs-5 ">
          If using the service internationally Control and manage the use by
          your staff locally and the ensure that 2-way messaging uses local
          2-way numbers.
        </p>
        <p className="fs-5 ">
          Broadcast empowers organisations to squeeze the most out of messaging
          with the maximum capability and the minimum of fuss, cost or
          disruption.
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
